<template>
  <component :is="`h${level}`" v-if="!link" class="font-semibold" :class="{ 'o-linkbox__overlay': overlay }" :title="title">
    {{ title }}
  </component>
  <a
    v-else
    v-bind="bind()"
    :href="articleUrl"
    @[isPreviewVideo&&`mouseover`]="emitHover(true)"
    @[isPreviewVideo&&`mouseleave`]="emitHover(false)"
  >
    <component :is="`h${level}`" class="font-semibold" :class="{ 'o-linkbox__overlay': overlay }" :title="title" v-bind="bindTitle">
      {{ title }}
    </component>
  </a>
</template>
<script>
import { defineComponent, inject, computed } from '@nuxtjs/composition-api';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { eventBus } from '~/modules/common/utils/eventBus';

export default defineComponent({
  props: {
    level: {
      type: Number,
      default: 3,
    },
    link: {
      type: Boolean,
      default: true,
    },
    overlay: {
      type: Boolean,
      default: true,
    },
    hp4uAttrs: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const article = inject('article', null);
    const title = computed(() => article?.title || props.title);
    const articleUrl = computed(() => getArticleUrl({ article }));
    const isPreviewVideo = computed(() => article?.preview || null);

    const emitHover = (status) => {
      eventBus.emit('playVideo', { status, id: article._id });
    };

    const bind = () => {
      const params = {};
      if (article?.redirectUrl) {
        params.rel = 'nofollow';
      }
      // Taboola Hp4u Attrs
      if (props.hp4uAttrs) {
        params['data-tb-link'] = '';
      }
      return params;
    };

    // Taboola Hp4u Attrs
    const bindTitle = props.hp4uAttrs ? { 'data-tb-title': '' } : {};

    return { title, articleUrl, bind, bindTitle, article, emitHover, isPreviewVideo };
  },
});
</script>
<style lang="scss" scoped>
.o-linkbox__overlay {
  position: static;
  &:before {
    content: '';
    cursor: inherit;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
  }
}
</style>
